import FamlaServices from './FamlaServices';
import type { NotificationMessage } from '../../components/notifications/ScrollingNotification';

export type InterviewRailApiData = {
    configured: boolean;
    messages: NotificationMessage[] | null;
};

export async function getInterviewRailNotifications(
    lang: string,
    accessToken: string | null | undefined
): Promise<InterviewRailApiData | null> {
    const l = (lang || 'en').toLowerCase().slice(0, 2) === 'fr' ? 'fr' : 'en';
    const url = `/app-content/interview-rail-notifications?lang=${encodeURIComponent(l)}`;
    const res = await FamlaServices('api_host', url, 'GET', '', accessToken || '');
    if (res.status !== 200 || !res.body) {
        return null;
    }
    const envelope = res.body as { data?: InterviewRailApiData };
    const data = envelope.data;
    if (data == null || typeof data !== 'object') return null;
    return {
        configured: Boolean(data.configured),
        messages: data.messages ?? null,
    };
}
